import { useEffect, useRef, useState } from "react";
import { Copy, FileDown } from "lucide-react";
import { toast } from "sonner";

export const EmailSignature = () => {
    const [html, setHtml] = useState("");
    const previewRef = useRef(null);

    useEffect(() => {
        fetch("/assets/firma-mino-cesari.html")
            .then((r) => r.text())
            .then(setHtml)
            .catch(() => {});
    }, []);

    const copySignature = () => {
        const el = previewRef.current;
        if (!el) return;
        const selection = window.getSelection();
        selection.removeAllRanges();
        const range = document.createRange();
        range.selectNodeContents(el);
        selection.addRange(range);
        let copied = false;
        try {
            copied = document.execCommand("copy");
        } catch {
            copied = false;
        }
        if (copied) {
            toast.success("Firma copiata", {
                description: "Ora incollala in Gmail: Impostazioni → Vedi tutte → Firma. Su Outlook: Impostazioni → Account → Firme.",
            });
        } else {
            toast("Firma selezionata", {
                description: "Dal telefono: tieni premuto sulla firma e scegli Copia. Dal computer: premi Ctrl+C.",
            });
        }
    };

    return (
        <div className="flex flex-col gap-5">
            <div
                ref={previewRef}
                data-testid="email-signature-preview"
                className="overflow-x-auto rounded-xl bg-white p-5"
                dangerouslySetInnerHTML={{ __html: html }}
            />
            <p className="font-code text-center text-[10px] uppercase leading-relaxed tracking-[0.2em] text-[#686f7c]">
                Gmail: Impostazioni → Vedi tutte → Firma → Incolla
                <br />
                Outlook: Impostazioni → Account → Firme → Incolla
            </p>
            <button
                data-testid="signature-copy-button"
                onClick={copySignature}
                className="group relative flex items-center justify-center gap-3 overflow-hidden rounded-xl bg-[#e2c075] px-6 py-4 transition-transform duration-300 active:scale-[0.98]"
            >
                <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
                <Copy className="h-4 w-4 shrink-0 text-[#090a0c]" />
                <span className="font-code whitespace-nowrap text-[11px] font-medium uppercase tracking-[0.2em] text-[#090a0c]">
                    Copia la firma
                </span>
            </button>
            <a
                data-testid="signature-download-button"
                href="/assets/firma-mino-cesari.html"
                download="firma-mino-cesari.html"
                className="flex items-center justify-center gap-2 rounded-xl border border-[rgba(226,192,117,0.3)] px-5 py-3.5 text-[#e2c075] transition-colors duration-300 hover:bg-[rgba(226,192,117,0.06)]"
            >
                <FileDown className="h-4 w-4" />
                <span className="font-code text-[11px] uppercase tracking-[0.2em]">Scarica il file HTML</span>
            </a>
        </div>
    );
};
